export default "assets/images/arch-deco-3a2f5c3d.svg";